
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { updateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import CopyrightIcon from '@mui/icons-material/Copyright';

const PasswordChange = () => {
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [changeStatus, setChangeStatus] = useState(null);
  const { isAuthenticated, userId, logout, token } = useAuth();
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    // Check if the token is expired
    if (isAuthenticated && tokenIsExpired(token)) {
      // Token is expired, log out the user
      logout();
    }
  }, [isAuthenticated, token, logout]);

  const handleOldPasswordChange = (e) => {
    setOldPassword(e.target.value);
  };

  const handleNewPasswordChange = (e) => {
    setNewPassword(e.target.value);
  };

  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value);
  };

  const validatePassword = () => {
    // Password must be at least 8 characters long
    if (newPassword.length < 8) {
      setErrorMessage('Password must be at least 8 characters long.');
      return false;
    }

    // Password must contain at least one uppercase letter
    if (!/[A-Z]/.test(newPassword)) {
      setErrorMessage('Password must contain at least one uppercase letter.');
      return false;
    }

    // Password must contain at least one lowercase letter
    if (!/[a-z]/.test(newPassword)) {
      setErrorMessage('Password must contain at least one lowercase letter.');
      return false;
    }

    // Password must contain at least one digit
    if (!/\d/.test(newPassword)) {
      setErrorMessage('Password must contain at least one digit.');
      return false;
    }

    // Passwords must match
    if (newPassword !== confirmPassword) {
      setErrorMessage('Passwords do not match.');
      return false;
    }

    // Password is valid
    setErrorMessage('');
    return true;
  };

  const handleChangePassword = async () => {
    if (!validatePassword()) {
      // Password validation failed
      return;
    }

    const createData = {
      CurrentPassword: oldPassword,
      NewPassword: newPassword,
      ConfirmPassword: confirmPassword,
      UserId: userId,
    };

    updateData('UserTokenApi', `${userId}`, createData, token)
      .then((response) => {
        setSuccessMessage(response.message);
        if (response.responseCode === '1111') {
          logout();
        }

      })
      .catch((error) => {
        setSuccessMessage('');
        console.error('Password Change error:', error);
      });
  };

  return (
    <div style={styles.container}>
      {successMessage && <p className="text-red-500">{successMessage}</p>}
      <h2 style={styles.title}>Password Change</h2>
      <label style={styles.label} htmlFor="oldPassword">
        Old Password:
      </label>
      <input
        type="password"
        id="oldPassword"
        value={oldPassword}
        onChange={handleOldPasswordChange}
        style={styles.input}
      />
      <label style={styles.label} htmlFor="newPassword">
        New Password:
      </label>
      <input
        type="password"
        id="newPassword"
        value={newPassword}
        onChange={handleNewPasswordChange}
        style={styles.input}
      />
      <label style={styles.label} htmlFor="confirmPassword">
        Confirm Password:
      </label>
      <input
        type="password"
        id="confirmPassword"
        value={confirmPassword}
        onChange={handleConfirmPasswordChange}
        style={styles.input}
      />
      <button onClick={handleChangePassword} style={styles.button}>
        Change Password
      </button>
      {changeStatus && <p style={styles.status}>{changeStatus}</p>}
      <div className="watermark">
        <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
      </div>
    </div>

  );
};

const styles = {
  container: {
    maxWidth: '400px',
    margin: 'auto',
    padding: '20px',
    border: '1px solid #ccc',
    borderRadius: '8px',
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
  },
  title: {
    fontSize: '1.5rem',
    marginBottom: '20px',
  },
  label: {
    display: 'block',
    marginBottom: '5px',
  },
  input: {
    width: '100%',
    padding: '8px',
    marginBottom: '15px',
    fontSize: '16px',
    borderRadius: '4px',
    border: '1px solid #ccc',
    boxSizing: 'border-box',
  },
  button: {
    backgroundColor: '#007bff',
    color: '#fff',
    padding: '10px',
    fontSize: '16px',
    borderRadius: '4px',
    cursor: 'pointer',
  },
  status: {
    marginTop: '15px',
    fontSize: '14px',
    color: '#007bff',
  },
};

export default PasswordChange;
